import React, { useEffect } from 'react';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import { ArrowRight } from 'react-bootstrap-icons';

const APPLICATIONS = [
  { name: 'Web', sku: 'PW001' },
  { name: 'QuickBooks', sku: 'INT011', description: 'Integración gratuita disponible en planes de 1,200 facturas en adelante', price: 0 },
  { name: 'Sage50/Peachtree', sku: 'INT002', description: 'Servicio de instalación, pago único, servicio de soporte/mantenimento anual $50 desde segundo año', price: 200 },
  { name: 'Zoho Books', sku: 'INT012', price:0 },
  { name: 'Loyverse', sku: 'INT010', price:0 },
  { name: 'Shopify', sku: 'INT004', price:200 },
  { name: 'WooCommerce', sku: 'INT003', price:200 },
  { name: 'Xero', sku: 'INT006', price:200 },
  { name: 'Odoo ERP', sku: 'INT005', price:200 },
  { name: 'API', sku: 'INT013', price:0 },
  //{ name: 'Otros', sku: 'APP-OTROS' },
];

const ALL_PLANS = [
  { id: 'FE120', folios: 120, friendlyName: '1 a 10 facturas mensuales', standardName: '120 Folios Anuales' },
  { id: 'FE600', folios: 600, friendlyName: '11 a 50 facturas mensuales', standardName: '600 Folios Anuales' },
  { id: 'FE1200', folios: 1200, friendlyName: 'Alrededor de 100 facturas mensuales', standardName: '1200 Folios Anuales' },
  { id: 'FE2400', folios: 2400, friendlyName: 'Hasta 2,400 facturas anuales', standardName: '2400 Folios Anuales' },
  { id: 'FE3600', folios: 3600, friendlyName: 'Hasta 3,600 facturas anuales', standardName: '3600 Folios Anuales' },
  { id: 'FE4800', folios: 4800, friendlyName: 'Hasta 4,800 facturas anuales', standardName: '4800 Folios Anuales' },
  { id: 'FE6000', folios: 6000, friendlyName: 'Hasta 6,000 facturas anuales', standardName: '6000 Folios Anuales' },
  { id: 'FE9000', folios: 9000, friendlyName: 'Hasta 9,000 facturas anuales', standardName: '9000 Folios Anuales' },
  { id: 'FE12K', folios: 12000, friendlyName: 'Hasta 12,000 facturas anuales', standardName: '12000 Folios Anuales' },
];

const DEFAULT_APPLICATION = APPLICATIONS.find(app => app.sku === 'PW001');
const DEFAULT_PLAN = ALL_PLANS.find(plan => plan.id === 'FE120');

const ApplicationCard = ({ app, isSelected, onSelect }) => (
  <Col md={4} className="mb-3">
    <Card
      className={`wizard-select-card h-100 text-center ${isSelected ? 'is-selected' : ''}`}
      onClick={() => onSelect(app)}
    >
      <Card.Body>
        <Card.Title className="h6">{app.name}</Card.Title>
        <Card.Text className="text-muted small">SKU: {app.sku}</Card.Text>
      </Card.Body>
    </Card>
  </Col>
);

const PlanCard = ({ plan, isSelected, onSelect }) => (
  <Col md={4} className="mb-3">
    <Card
      className={`wizard-select-card h-100 text-center ${isSelected ? 'is-selected' : ''}`}
      onClick={() => onSelect(plan)}
    >
      <Card.Body>
        <Card.Title className="h6 wizard-plan-title">{plan.friendlyName}</Card.Title>
        <Card.Text className="text-muted small">{plan.standardName}</Card.Text>
      </Card.Body>
    </Card>
  </Col>
);

const Step2Service = ({ onNext, onBack, data, updateFormData }) => {
  useEffect(() => {
    if (!data.application && DEFAULT_APPLICATION) {
      updateFormData({
        ...data,
        application: DEFAULT_APPLICATION.name,
        applicationSku: DEFAULT_APPLICATION.sku,
        plan: data.plan || DEFAULT_PLAN || null,
      });
    } else if (data.application === DEFAULT_APPLICATION?.name && !data.plan && DEFAULT_PLAN) {
      updateFormData({
        ...data,
        plan: DEFAULT_PLAN,
      });
    }
  }, [data, updateFormData]);

  const handleAppSelect = (app) => {
    const isRestrictedApp = ['QuickBooks', 'Zoho Books'].includes(app.name);
    const shouldResetPlan = isRestrictedApp && data.plan?.folios < 1200;

    const nextServiceData = {
      ...data,
      application: app.name,
      applicationSku: app.sku,
      plan: shouldResetPlan ? null : data.plan,
    };

    if (app.name === 'Otros') {
      nextServiceData.otherDescription = data.otherDescription || '';
    } else if (data.otherDescription) {
      nextServiceData.otherDescription = '';
    }

    updateFormData(nextServiceData);
  };

  const handleOtherDescriptionChange = (e) => {
    updateFormData({
      ...data,
      otherDescription: e.target.value,
    });
  };

  const handlePlanSelect = (plan) => {
    updateFormData({ ...data, plan });
  };

  const selectedApp = data.application || '';
  const selectedSku = data.applicationSku || '';
  const isRestricted = ['QuickBooks', 'Zoho Books'].includes(selectedApp);
  const availablePlans = isRestricted ? ALL_PLANS.filter(p => p.folios >= 1200) : ALL_PLANS;

  const isNextDisabled = !selectedApp || !selectedSku || !data.plan || (selectedApp === 'Otros' && !data.otherDescription?.trim());

  return (
    <div className="p-4">
      <div className="wizard-header">
        <h4 className="mb-0">Aplicación y Plan</h4>
      </div>

      <h5>Selección de Aplicación</h5>
      <Row className="mb-4">
        {APPLICATIONS.map(app => (
          <ApplicationCard
            key={app.sku}
            app={app}
            isSelected={selectedApp === app.name}
            onSelect={handleAppSelect}
          />
        ))}
      </Row>

      {selectedApp === 'Otros' && (
        <Form.Group className="mb-4" controlId="otherDescription">
          <Form.Label>Descripción para "Otros"</Form.Label>
          <Form.Control
            type="text"
            name="otherDescription"
            value={data.otherDescription || ''}
            onChange={handleOtherDescriptionChange}
          />
        </Form.Group>
      )}

      {selectedApp && (
        <>
          <h5 className="mt-4">Selección del Plan de Suscripción</h5>
          <Row>
            {availablePlans.map(plan => (
              <PlanCard
                key={plan.id}
                plan={plan}
                isSelected={data.plan?.id === plan.id}
                onSelect={handlePlanSelect}
              />
            ))}
          </Row>
        </>
      )}

      <div className="d-flex justify-content-between mt-4">
        <Button variant="secondary" onClick={onBack}>Anterior</Button>
        <Button
          onClick={onNext}
          disabled={isNextDisabled}
          variant="primary"
          className="d-inline-flex align-items-center gap-2"
        >
          Siguiente
          <ArrowRight size={18} />
        </Button>
      </div>
    </div>
  );
};

export default Step2Service;
